// extracted by mini-css-extract-plugin
export default {"link":"NavItem_link__6C5RX","active":"NavItem_active__VPLMt","disabled":"NavItem_disabled__eYxMf","placeHolderShimmer":"NavItem_placeHolderShimmer__86H1z"};